import React, { Component } from "react";

import { Link } from "react-router-dom";

import { Element } from "react-scroll";



export default class Alojamento extends Component {
  render() {
    return (
      <section id="alojamento">
        <Element name="alojamentoElement" />
        <h1>Alojamento</h1>

        <div className="section-background">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-9 col-lg-7">
              
                <p className="background-texto-principal">
                  Encontre o seu cantinho e descanse na nossa aldeia
                </p>

                <div className="bottom-align-background" >
                  <p className="background-texto-secundario">
                    Variadas soluções de alojamento à sua escolha, entre hotéis, alojamento local, turismo rural entre outros para que possa desfrutar ao máximo da sua viagem.
                  </p>
                  <Link to="/alojamentos">
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-above-image"
                    >
                      <span>Alojamentos</span>
                    </button>
                  </Link>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
